import * as $ from "jquery";

$(document).ready(function () {
  // Add archive filtering
  $("#archives-filter").on("submit", function (event) {
    event.preventDefault();
  });

  // Filter by product
  $("#archives-filter .field-type-select select[name='products']").on(
    "change",
    function () {
      var $select = $(this);
      var selectedValue = $select.val();

      if (!selectedValue) {
        $(".block__view__list__item").show();
        return;
      }

      $(".block__view__list__item").each(function () {
        var $listItem = $(this);

        if ($listItem.data("filter").indexOf(selectedValue) == -1) {
          $listItem.hide();
        } else {
          $listItem.show();
        }
      });
    }
  );

  // Filter by date
  $("#archives-filter .field-type-select select[name='sort_by']").on(
    "change",
    function () {
      var $select = $(this);
      var selectedValue = $select.val();

      if (selectedValue === "newer") {
        $(".block__view__list__item")
          .sort(sort_li_newer)
          .appendTo(".block__view__list");
      } else {
        $(".block__view__list__item")
          .sort(sort_li_older)
          .appendTo(".block__view__list");
      }

      function sort_li_newer(a: HTMLElement, b: HTMLElement) {
        return $(b).data("filter-date") > $(a).data("filter-date") ? 1 : -1;
      }

      function sort_li_older(a: HTMLElement, b: HTMLElement) {
        return $(b).data("filter-date") < $(a).data("filter-date") ? 1 : -1;
      }
    }
  );

  // Fix date formats
  $(".block__view__field--publishDate").each(function () {
    var articleDate = $(this).text().trim();
    if (articleDate.indexOf(":") > -1) {
      var monthNames = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];

      var parsedDate = Date.parse(articleDate);
      var thisDate = new Date(parsedDate);

      var thisDateMonth = thisDate.getMonth();
      var thisMonth = monthNames[thisDateMonth];
      var thisDay = thisDate.getDate();
      var thisYear = thisDate.getFullYear();

      var formatDate = thisMonth + " " + thisDay + ", " + thisYear;

      if ($(this).hasClass("lng-ja")) {
        formatDate = `${thisYear}年${thisDateMonth + 1}月${thisDay}日`;
      }

      $(this).text(formatDate);
    }
  });
});
